import {gql} from "@apollo/client";
import {StaffingFormInput} from "../../domain";
import {getDomainGraphqlError, useMutation$} from "../../../../graphqlsupport";
import {useCallback} from "react";
import {showToast} from "common";


const GRAPHQL_MUTATION = gql`
mutation submitAuthStaffingPlan($input: StaffingPlanInput) {
    submitAuthStaffingPlan(input: $input) {
        guid
    }
}`;

type AuthStaffingPlanInput = StaffingFormInput & {
    authorizationGuid: string;
}

export function useAuthStaffingPlan (authorizationGuid: string) {
    const {execute,} = useMutation$<{input: AuthStaffingPlanInput}, void>(GRAPHQL_MUTATION);
    const submitStaffingPlan = useCallback(async function (formValues: StaffingFormInput | null) {
        if (formValues == null) {
            return;
        }

        try {
            await execute({
                variables: {
                    input: {
                        ...formValues,
                        authorizationGuid,
                    },
                }
            });
            showToast.success('Successfully Submit Staffing Plan');
        } catch (errors: any) {
            if (getDomainGraphqlError(errors)) {
                showToast.error(getDomainGraphqlError(errors));
            } else {
                showToast.error(`Unable to submit reason by ${errors.message || errors[0].message}`);
            }
        }
    }, [authorizationGuid, execute]);

    return {
        submitStaffingPlan
    }
}
